import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Table,
  TextField,
  TableHead,
  Button,
  TableBody,
  TableRow,
  Paper,
  TableCell,
  TableContainer,
  TablePagination,
  FormControlLabel,
} from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import Navbar from "../pages/Navbar";
import Sidebar from "../pages/Sidebar";
import Typography from "@mui/material/Typography";

const PendingAcceptance = () => {
  const { assetType } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { API_CONFIG } = require("../configuration");

  useEffect(() => {
    setFilteredRows(rows);
  }, [rows]);
  useEffect(() => {
    fetchData();
  }, [assetType]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      const branch = user.branch;

      const res = await axios.get(
        `${API_CONFIG.APIURL}/dashboard/pending-assets/${encodeURIComponent(
          branch,
        )}/${assetType}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setRows(
        (res.data.data || []).map((row) => ({
          ...row,
          remarks: "",
        })),
      );
    } catch (err) {
      console.error("Fetch pending assets error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchQuery(value);

    const filtered = rows.filter(
      (row) =>
        row.asset_id?.toLowerCase().includes(value) ||
        row.asset_type?.toLowerCase().includes(value) ||
        row.brand?.toLowerCase().includes(value) ||
        row.model?.toLowerCase().includes(value) ||
        row.imei_num?.toLowerCase().includes(value),
    );

    setFilteredRows(filtered);
  };
  const handleRemarksChange = (index, value) => {
    const updated = [...rows];
    updated[index].remarks = value;
    setRows(updated);
  };

  const handleSelectAsset = (assetId) => {
    setSelectedAssets((prev) =>
      prev.includes(assetId)
        ? prev.filter((id) => id !== assetId)
        : [...prev, assetId],
    );
  };
  const handleSelectAll = (checked) => {
    const selectableRows = filteredRows
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .filter((row) => row.status !== "APPROVAL_PENDING");

    if (checked) {
      setSelectedAssets(selectableRows.map((row) => row.asset_id));
    } else {
      setSelectedAssets([]);
    }
  };

  const allSelected =
    filteredRows.length > 0 &&
    filteredRows
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .every((row) => selectedAssets.includes(row.asset_id));

  const handleBulkAction = async (action) => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user")); // FIX

      const selectedRows = rows.filter((row) =>
        selectedAssets.includes(row.asset_id),
      );

      const payload = {
        action,
        emp_id: user?.emp_id,
        assets: selectedRows.map((row) => ({
          asset_id: row.asset_id,
          remarks: row.remarks || "",
        })),
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${API_CONFIG.APIURL}/dashboard/acceptance-action`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.success) {
        alert(response.data.message);

        setSelectedAssets([]);
        fetchData();
      }
    } catch (error) {
      console.error("Acceptance Action Error:", error);

      alert(
        error?.response?.data?.message || "Failed to process asset acceptance",
      );
    }
  };
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <Navbar />
      <Sidebar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { xs: 0, md: "250px" }, // adjust if sidebar width = 250px
          width: { xs: "100%", md: "calc(100% - 250px)" },
          p: 3,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            fontWeight: 700,
            mb: 3,
            textTransform: "capitalize",
            color: "#1f2a44",
          }}
        >
          {assetType} Pending Acceptance
        </Typography>

        <Paper
          elevation={2}
          sx={{
            p: 2,
            mb: 1,
            borderRadius: 2,
          }}
        >
          <TextField
            size="small"
            placeholder="Search Assets..."
            value={searchQuery}
            onChange={handleSearch}
            sx={{ width: 350 }}
          />
        </Paper>

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: 3,
            flex: 1,
            minHeight: 0,
            overflow: "auto", // keep this
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <Checkbox
                    checked={allSelected}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Asset ID
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Asset Type
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Brand
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Model
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Serial No
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Status
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#a2b0cc",
                    fontWeight: 700,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow
                    key={row.asset_id}
                    hover
                    selected={selectedAssets.includes(row.asset_id)}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: "rgba(25,118,210,0.08)",
                      },
                    }}
                  >
                    <TableCell>
                      <TableCell>
                        {row.status !== "APPROVAL_PENDING" ? (
                          <Checkbox
                            checked={selectedAssets.includes(row.asset_id)}
                            onChange={() => handleSelectAsset(row.asset_id)}
                          />
                        ) : null}
                      </TableCell>
                    </TableCell>

                    <TableCell>{row.asset_id}</TableCell>
                    <TableCell>{row.asset_type}</TableCell>
                    <TableCell>{row.brand}</TableCell>
                    <TableCell>{row.model}</TableCell>
                    <TableCell>{row.imei_num}</TableCell>

                    <TableCell>
                      <Box
                        sx={{
                          bgcolor:
                            row.status === "PENDING" ? "#fff3cd" : "#d4edda",
                          color:
                            row.status === "PENDING" ? "#856404" : "#155724",
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          display: "inline-block",
                          fontWeight: 600,
                          fontSize: "12px",
                        }}
                      >
                        {row.status}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <TextField
                        size="small"
                        fullWidth
                        placeholder="Enter Remarks"
                        value={row.remarks}
                        disabled={!selectedAssets.includes(row.asset_id)}
                        onChange={(e) =>
                          handleRemarksChange(
                            rows.findIndex((r) => r.asset_id === row.asset_id),
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Paper
          elevation={2}
          sx={{
            mt: 1,
            p: 2,
            borderRadius: 2,
            flexShrink: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: 56,
              overflow: "hidden",
            }}
          >
            <TablePagination
              component="div"
              count={filteredRows.length}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{
                ".MuiTablePagination-toolbar": {
                  minHeight: "48px",
                  paddingLeft: 0,
                  paddingRight: 0,
                },
              }}
            />

            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                color="success"
                size="large"
                disabled={selectedAssets.length === 0}
                onClick={() => handleBulkAction("ACCEPT")}
              >
                Accept
              </Button>

              <Button
                variant="contained"
                color="error"
                size="large"
                disabled={selectedAssets.length === 0}
                onClick={() => {
                  navigate("/DashBoard");
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default PendingAcceptance;
